// Fragment "tenant notification settings" — the notifications card in SettingsAdmin
// (admin/settings/NotificationSettingsCard.jsx + useNotificationSettings.js).
// Key list is fixed by docs/auth-and-admin/notification-settings.md. Merged in ./index.js.
export default {
  fr: {
    "settings.notif.title": "Notifications par courriel",
    "settings.notif.subtitle": "Recevez un courriel lorsqu'un client réserve, achète ou vous écrit.",
    "settings.notif.master": "Activer les notifications",
    "settings.notif.booking": "Réservations",
    "settings.notif.bookingHint": "Nouvelle demande de rendez-vous ou réservation payée.",
    "settings.notif.purchase": "Ventes",
    "settings.notif.purchaseHint": "Cours, produits, programmes, factures, cartes-cadeaux et télésanté.",
    "settings.notif.messages": "Messages des clients",
    "settings.notif.messagesHint": "Un courriel lorsqu'un client vous écrit — un seul par échange non lu.",
    "settings.notif.recipient": "Adresse de réception",
    "settings.notif.recipientHint": "Laissez vide pour utiliser le courriel du propriétaire.",
    "settings.notif.save": "Enregistrer",
    "settings.notif.saved": "Enregistré",
    "settings.notif.invalidEmail": "Adresse courriel invalide.",
  },
  en: {
    "settings.notif.title": "Email notifications",
    "settings.notif.subtitle": "Receive an email when a client books, buys or writes to you.",
    "settings.notif.master": "Enable notifications",
    "settings.notif.booking": "Bookings",
    "settings.notif.bookingHint": "New appointment request or paid booking.",
    "settings.notif.purchase": "Sales",
    "settings.notif.purchaseHint": "Courses, products, programs, invoices, gift cards and telehealth.",
    "settings.notif.messages": "Client messages",
    "settings.notif.messagesHint": "An email when a client writes to you — one per unread exchange, not one per message.",
    "settings.notif.recipient": "Recipient address",
    "settings.notif.recipientHint": "Leave blank to use the owner's email.",
    "settings.notif.save": "Save",
    "settings.notif.saved": "Saved",
    "settings.notif.invalidEmail": "Invalid email address.",
  },
  es: {
    "settings.notif.title": "Notificaciones por correo",
    "settings.notif.subtitle": "Reciba un correo cuando un cliente reserve, compre o le escriba.",
    "settings.notif.master": "Activar las notificaciones",
    "settings.notif.booking": "Reservas",
    "settings.notif.bookingHint": "Nueva solicitud de cita o reserva pagada.",
    "settings.notif.purchase": "Ventas",
    "settings.notif.purchaseHint": "Cursos, productos, programas, facturas, tarjetas de regalo y telesalud.",
    "settings.notif.messages": "Mensajes de clientes",
    "settings.notif.messagesHint": "Un correo cuando un cliente le escribe — uno por intercambio no leído, no uno por mensaje.",
    "settings.notif.recipient": "Dirección de recepción",
    "settings.notif.recipientHint": "Déjelo vacío para usar el correo del propietario.",
    "settings.notif.save": "Guardar",
    "settings.notif.saved": "Guardado",
    "settings.notif.invalidEmail": "Dirección de correo no válida.",
  },
};
